import Box from './Box';

export default function Chip({ active }) {
	return (
		<Box name="chip" classes={active ? ['active'] : []}>
			{active ? 'Initialised' : 'Not initialised'}
		</Box>
	);
}
